module.exports = __webpack_public_path__ + "static/media/closing-title.0c95bb6c.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/closing-title.webm
// module id = 54
// module chunks = 0